import SectionLabel from "@/components/SectionLabel";
import { CLINIC } from "@/lib/clinic";
import { ShieldCheck, HeartHandshake, Scale, Sparkles, Award, Users } from "lucide-react";

const values = [
  { icon: HeartHandshake, t: "Compassion" }, { icon: ShieldCheck, t: "Integrity" },
  { icon: Award, t: "Excellence" }, { icon: Users, t: "Trust" },
  { icon: Scale, t: "Respect" }, { icon: Sparkles, t: "Patient First" },
];

export default function About() {
  return (
    <div>
      <section className="py-16 lg:py-24 bg-white">
        <div className="max-w-6xl mx-auto px-6 lg:px-10">
          <SectionLabel>About the Clinic</SectionLabel>
          <h1 className="font-serif text-4xl md:text-5xl tracking-tight text-slate-900 max-w-3xl">
            A quiet, dependable clinic where families have come home for over three and a half decades.
          </h1>
          <p className="mt-6 text-slate-600 max-w-3xl leading-relaxed text-lg">
            Aarogya Clinic in Ayodhya Bypass, Bhopal, is led by Dr. V. K. Onkar — a physician
            whose reputation was built one honest consultation at a time, first at BHEL Bhopal
            (where he served as Assistant General Manager, Medical) and now in independent
            family practice.
          </p>
        </div>
      </section>

      <section className="py-16" style={{ background: "#F1F6FB" }}>
        <div className="max-w-6xl mx-auto px-6 lg:px-10 grid md:grid-cols-2 gap-6">
          <div className="rounded-3xl bg-white p-8 aarogya-shadow border border-slate-200/60">
            <SectionLabel>Our Mission</SectionLabel>
            <p className="font-serif text-2xl leading-snug text-slate-900">
              To deliver ethical, evidence-based and affordable healthcare — while building
              lifelong relationships with patients and their families.
            </p>
          </div>
          <div className="rounded-3xl p-8 aarogya-shadow text-white" style={{ background: "linear-gradient(135deg,#0A6EBD,#16A5B8)" }}>
            <div className="text-[11px] font-bold tracking-[0.24em] uppercase text-teal-100 mb-3">Our Vision</div>
            <p className="font-serif text-2xl leading-snug">
              To be Bhopal's most trusted family clinic — combining medical expertise with
              compassionate care, generation after generation.
            </p>
          </div>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-6xl mx-auto px-6 lg:px-10">
          <SectionLabel>Core Values</SectionLabel>
          <div className="mt-6 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3">
            {values.map((v, i) => (
              <div key={i} className="rounded-2xl border border-slate-200/70 bg-white p-5 aarogya-shadow hover:-translate-y-0.5 transition"
                   data-testid={`value-${v.t.toLowerCase()}`}>
                <v.icon className="h-6 w-6 text-[#0A6EBD]" />
                <div className="mt-3 font-semibold text-slate-800">{v.t}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 lg:py-20" style={{ background: "#F1F6FB" }}>
        <div className="max-w-6xl mx-auto px-6 lg:px-10 grid md:grid-cols-2 gap-10 items-center">
          <img src="https://images.pexels.com/photos/7789603/pexels-photo-7789603.jpeg?auto=compress&cs=tinysrgb&w=1200"
               alt="Clean, modern clinic interior" className="rounded-3xl aarogya-shadow-lg w-full h-[420px] object-cover" />
          <div>
            <SectionLabel>Hygiene & Safety</SectionLabel>
            <h2 className="font-serif text-3xl text-slate-900 tracking-tight">Sanitized rooms. Safe practices. Peace of mind.</h2>
            <ul className="mt-6 space-y-3 text-slate-700">
              {["Sanitized consultation rooms after each patient","Safe medical practices & sterile technique","Clean, comfortable waiting area","Strict patient-safety protocols"].map((x, i) => (
                <li key={i} className="flex items-start gap-3">
                  <span className="mt-2 h-1.5 w-1.5 rounded-full bg-[#0A6EBD]"></span> {x}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-6xl mx-auto px-6 lg:px-10 text-center">
          <SectionLabel>Address</SectionLabel>
          <p className="font-serif text-2xl text-slate-900">
            {CLINIC.address.line1}, {CLINIC.address.line2}, {CLINIC.address.city} – {CLINIC.address.pin}
          </p>
        </div>
      </section>
    </div>
  );
}
